import moment from "moment";

const DateField = (props: any) => {
    return (
        <div>
           <span>{moment(props.Fecha).format('DD/MM/YYYY')}</span>
        </div>
    )
}
export default DateField;